import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const location = useLocation();
  const prevLocationRef = useRef(location);

  useEffect(() => {
    const prevLocation = prevLocationRef.current;
    prevLocationRef.current = location;

    // Opening/closing the Wolt-style product sheet (App.js) pushes/pops a
    // history entry too, but it's an overlay on the same background page —
    // the window itself must stay exactly where it was, not jump to top.
    const isSheetTransition =
      Boolean(location.state?.backgroundLocation) ||
      Boolean(prevLocation.state?.backgroundLocation);

    if (!location.hash && !isSheetTransition) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);

  return null;
}

export default ScrollToTop;